import {
  IncidentAttributeId,
  VolleyballAttributeId,
} from '@collector/sportsapi-client-legacy'
import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { IncidentDetailsFillState } from '@mobile/views/Relation/DetailsPanel/enums'

import { DetailConfiguration } from '../../../../composables/useSportOptions'
import { getIncidentAttributesDetailsFillState } from '../../../../Modals/utils'

export function isZoneAttributeSelected<T extends VolleyballAttributeId>(
  incidentAttributes: IncidentAttributeId[],
  zoneAttributes: T[],
): boolean {
  return incidentAttributes.some((attr) => zoneAttributes.includes(attr as T))
}

export function removeZoneAttributes<T extends VolleyballAttributeId>(
  attributes: T[],
  zones: Map<number, T>,
): T[] {
  const zoneAttributeValues = new Set(zones.values())
  return attributes.filter((id) => !zoneAttributeValues.has(id as T)) ?? []
}

export function filterAttributesBasedOnSelectedZone<
  T extends VolleyballAttributeId,
>(
  baseAttributes: T[],
  zones: Map<number, T>,
  selectedZone: number | null,
): T[] {
  if (selectedZone === null) {
    return removeZoneAttributes(baseAttributes, zones)
  }

  const attributeId = zones.get(selectedZone)
  if (!attributeId) {
    throw new Error('Zone attribute id not found')
  }

  const otherAttributes = removeZoneAttributes(baseAttributes, zones)

  return [...otherAttributes, attributeId]
}

export function getIncidentDetailsFillState<T extends IncidentAttributeId>(
  groups: Map<unknown, DetailConfiguration<T>>,
  incident: ProbableIncident,
): {
  state: IncidentDetailsFillState
} {
  if (!incident.attribute_ids) {
    return { state: IncidentDetailsFillState.NotFilled }
  }

  const state = getIncidentAttributesDetailsFillState(groups, incident)

  return { state }
}
